import type { ColorResult } from '~/_shared/components/colorPicker/colorPicker.types';
import { type UnitSystem } from '~/_shared/types/googleMaps/googleMaps.types';
import {
  type GroupRadiusEditLevel,
  type ProximityType,
} from '~/_shared/types/proximity/proximity.enums';
import { type SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { type GeoLocation } from '~/_shared/utils/geolocation/geolocation';
import type { ExportDataFileType } from '~/data/exportDataModal/exportDataFileType.enum';
import type { ExportProximityDistanceCalculate } from '~/proximityDetails/export/exportProximityDistanceCalculateMothodSection.component';
import type { ExportProximityLimits } from '~/proximityDetails/export/exportProximityLimitResultsSection.component';
import type { ItemizedExportId } from '~/spreadsheet/itemizeExport.repository';
import { type GroupData } from '../../spreadsheetData/spreadsheetData.state';

export enum ExportProximityResultType {
  Success = 'Success',
  Error = 'Error',
  Pending = 'Pending',
}

export type ExportProximityDataParams = Readonly<{
  spreadsheetId: number;
  proximityIds: ReadonlyArray<Uuid>;
  selectedSpreadsheetRowId: SpreadsheetRowId | null;
  exportAsText: boolean;
  extension: ExportDataFileType;
  exportLimits: ExportProximityLimits;
  distanceCalculate: ExportProximityDistanceCalculate;
}>;

export type ExportProximitySuccessResultData = Readonly<{
  nextPageId?: ItemizedExportId;
  file?: string;
  data?: string;
}>;

export type ExportProximityResult = Readonly<{
  type: ExportProximityResultType.Success;
  data: ExportProximitySuccessResultData;
  error: null;
} | {
  type: ExportProximityResultType.Error;
  data: null;
  error: string;
} | {
  type: ExportProximityResultType.Pending;
  data: null;
  error: null;
}>;

export type ProximityToolState = {
  applyTo: GroupRadiusEditLevel;
  type: ProximityType;
  unit: UnitSystem;
  travelTimeHours: number | null;
  travelTimeMinutes: number | null;
  proximityWithin: number | null;
  selectedGroup: GroupData | null;
  selectedGroupColumn: SpreadsheetColumnId | null;
  proximityColor: ColorResult;
  borderColor: ColorResult;
  borderLineWidth: number;
  startingLocation: GeoLocation;
  proximityIdInDnDMode: string | null;
  exports: ReadonlyArray<Readonly<{
    id: Uuid;
    request: ExportProximityDataParams;
    resultPages: ReadonlyArray<ExportProximityResult>;
  }>>;
};
